module.exports = __webpack_public_path__ + "img/couples-028.aee719d0.jpg";